import { render } from "./WarehouseCard.vue?vue&type=template&id=1a24996f"
import script from "./WarehouseCard.vue?vue&type=script&lang=js"
export * from "./WarehouseCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__